import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import WhatsAppOpener from "../../components/WhatsAppOpener";
import EmailForm from "../sendEmail/EmailForm";
const PDFSendWhatsAppDialog = ({
  reportNo,
  jobNo,
  loggedUserData,
  labRequestId,
  open,
  handleCloseReportPreview,
  contactNo,
  sendReportType,
  emailAddress,
  jobId,
}) => {
  return (
    <div>
      <Dialog
        open={open}
        maxWidth="xl"
        onClose={handleCloseReportPreview}
        aria-labelledby="responsive-dialog-title"
        sx={{ width: "100%" }}
      >
        <DialogTitle id="responsive-dialog-title">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography variant="h4" color="success">
              {" "}
              DOCUMENT IS READY FOR DOWNLOADING
            </Typography>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div>
            {sendReportType === "WHATSAPP" ? (
              <WhatsAppOpener
                jobNo={jobNo}
                reportNo={reportNo}
                labRequestId={labRequestId}
                loggedUserData={loggedUserData}
                contactNo={contactNo}
                jobId={jobId}
              />
            ) : sendReportType === "EMAIL" ? (
              <EmailForm
                jobNo={jobNo}
                reportNo={reportNo}
                labRequestId={labRequestId}
                loggedUserData={loggedUserData}
                emailAddress={emailAddress}
                jobId={jobId}
              />
            ) : sendReportType === "BLOCK" ? (
              ""
            ) : (
              ""
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PDFSendWhatsAppDialog;
